import React from "react";
import { withRouter } from "react-router-dom";
import Header from "../presentational/Header";

const HeaderContainer = (props) => {
    return (
        <Header />
    );
}

export default withRouter(HeaderContainer);



// WEBPACK FOOTER //
// ./src/containers/Header.js